// Feed cruzado de historias clínicas (Rediseño mayor 2026-09-02, Fase 3
// "destinos reales del nav") — últimas entradas clínicas de varios
// pacientes a la vez (GET /api/hce/historias-feed). Cada fila navega a la
// pestaña Historia del paciente correspondiente.
import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { TopNav } from '@/dashboard/TopNav';
import { obtenerFeedHistorias, type FeedHistorias } from '@/lib/hceVault';

export function HistoriasPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [feed, setFeed] = useState<FeedHistorias | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    obtenerFeedHistorias()
      .then(setFeed)
      .catch(() => setError(t('historias.errorCargar')));
  }, [t]);

  return (
    <div className="mx-auto max-w-4xl space-y-4 py-4">
      <TopNav activo="historias" />
      <h1 className="text-lg font-medium text-hce-ink">{t('historias.titulo')}</h1>
      {feed && feed.pacientesIncluidos < feed.totalPacientes && (
        <p className="text-xs text-hce-muted">
          {t('historias.corte', { incluidos: feed.pacientesIncluidos, total: feed.totalPacientes })}
        </p>
      )}
      {error && <p className="text-sm text-destructive">{error}</p>}

      <div className="rounded-lg border border-border bg-card">
        {!feed ? (
          <p className="p-4 text-sm text-hce-muted">{t('dashboard.cargando')}</p>
        ) : feed.entradas.length === 0 ? (
          <p className="p-4 text-sm text-hce-muted">{t('historias.sinEntradas')}</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t('historias.fecha')}</TableHead>
                <TableHead>{t('historias.paciente')}</TableHead>
                <TableHead>{t('historias.evento')}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {feed.entradas.map((e, i) => (
                <TableRow key={i} className="cursor-pointer" onClick={() => void navigate(`/${e.patientId}/historia`)}>
                  <TableCell className="text-hce-muted">{new Date(e.fecha).toLocaleDateString('es-EC')}</TableCell>
                  <TableCell className="text-hce-ink">{e.patientName}</TableCell>
                  <TableCell className="text-hce-muted">{e.texto}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
}
